import type { MakeHandleSubmitFn } from '@ipfabric/ui-components/utils/formSnippets/useFormComposition';
import type { ReactNode } from 'react';
import type { DiscoverySettingsObject } from '../../model/DiscoverySettingsObject';
import { wizardStepsConfig } from './wizardConfig';

type RawStepIndexKeys = Exclude<keyof typeof wizardStepsConfig, keyof any[]>;
// Derive numeric tuple indices (e.g. 0 | 1 | 2 | 3) instead of string keys ("0" | "1" | ...)
export type StepIndex = RawStepIndexKeys extends `${infer N extends number}`
  ? N
  : never;

export const isStepIndex = (value: number | null): value is StepIndex => {
  if (value === null) {
    return false;
  }
  return (
    value >= 0 && value < wizardStepsConfig.length && Number.isInteger(value)
  );
};

export interface WizardPageProps {
  onSubmit: (discoverySettingsObject: DiscoverySettingsObject) => Promise<void>;
  wizardStepper: (
    isSubmitting?: boolean,
    handleSubmit?: MakeHandleSubmitFn,
    disabled?: boolean,
  ) => ReactNode;
  onPreviousStep: () => void;
  onNextStep: () => void;
  onFinalSubmit: (
    discoverySettingsObject: DiscoverySettingsObject,
  ) => Promise<void>;
}
